import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getBackofficeUsersV2 = createAction('GET_BACKOFFICE_USERS_V2');
export const setBackofficeUsersV2 = createAction('SET_BACKOFFICE_USERS_V2');
export const createBackofficeUserV2 = createAction('CREATE_BACKOFFICE_USER_V2');
export const updateBackofficeUserV2 = createAction('UPDATE_BACKOFFICE_USER_V2');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
      setBackofficeUsersV2,
      (state, action) => {
        return {
          ...state,
          users: action.payload
        }
      } 
    ]
  ]),
  { users: [] } 
);
